export const NETWORKS = {
    bsc: {
        name: 'Binance Smart Chain',
        rpc: 'https://bsc-dataseed1.binance.org/',
        positionManager: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
        dataPoolGetter: '0x23237aa092b98F5B2D6Bd27dCc6Fd10d4dEB50D8',
        explorer: 'https://bscscan.com',
    },
    base: {
        name: 'Base',
        rpc: 'https://mainnet.base.org',
        positionManager: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
        dataPoolGetter: '0x65B8821160a94a1D328Bf480e0355f051921d11d',
        explorer: 'https://basescan.org',
    }
};